import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';

const Th = styled.td`
  ${({ displayState }) => css`
    ${displayState?.borderRight && css`
      border-right: ${displayState.borderRight};
    `}
    ${displayState?.background && css`
      background: ${displayState.background};
    `}
  `} 
`;

export default Wrapper(Th)